import { TextField } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

interface ConfirmCheckoutReferenceNumberProps {
  referenceNumber: string
  onReferenceNumberChange(referenceNumber: string): void
}

const useStyles = makeStyles()(theme => ({
  container: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    minHeight: '177px',
  },
  normalText: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.grey.grey03,
  },
  inputField: {
    marginTop: theme.spacing(4),
  },
}))

/*
 * This component handle an optional input field "Reference Number" if user want to pass an reference number on order.
 */
const ConfirmCheckoutReferenceNumber: React.FC<ConfirmCheckoutReferenceNumberProps> = ({ referenceNumber, onReferenceNumberChange }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  return (
    <Grid item xs={12} md={6} className={classes.container}>
      <Typography variant="h2" sx={{ fontWeight: 400 }} className={classes.normalText}>
        {t('shop.confirm-checkout.reference-number')}
      </Typography>
      <Divider className={classes.normalText} variant="fullWidth" />
      <TextField
        className={classes.inputField}
        label={t('shop.confirm-checkout.reference-number-label')}
        value={referenceNumber}
        onChange={event => onReferenceNumberChange(event.target.value)}
        fullWidth
      />
    </Grid>
  )
}

export default ConfirmCheckoutReferenceNumber
